var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "text-center" }, [
      _c("h3", [_vm._v("En Construction")]),
      _c("h3", [
        _c("a", { attrs: { href: "/" } }, [_vm._v("Retour à l'accueil")])
      ]),
      _c("img", {
        attrs: {
          src: require("../../public/assets/images/icon-en-construction.png"),
          alt: ""
        }
      })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }